









import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import TopBar from '@/components/TopBar/TopBar.vue';
import InputField from '@/components/InputField/InputField.vue';
import TypeaheadList from '@/components/TypeaheadList/TypeaheadList.vue';

@Component({
	components: {
		TopBar,
		InputField,
		TypeaheadList,
	},
})
export default class Home extends Vue {
	@Getter private activeId!: number;
}
